import { DefaultPaymentMethods } from "../../../domain/invoicing/settings/invoicingSettings"
import VSpace from "../../common/VSpace"
import CheckboxButton from "../../common/CheckboxButton"
import SettingsTitledCard from "../SettingsTitledCard"
import { Space } from "antd"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faBank, faCreditCard } from "@fortawesome/pro-solid-svg-icons"

type Props = {
  defaultPaymentMethods: DefaultPaymentMethods
  onUpdate: (updated: DefaultPaymentMethods) => void
}

const DefaultPaymentMethodsCard = ({defaultPaymentMethods, onUpdate}: Props) => {
  return <SettingsTitledCard
    title="Default Payment Methods"
    description="Select the default payment methods your customers can use to pay their invoices."
  >
    <VSpace>
      <CheckboxButton
        checked={defaultPaymentMethods.creditCard}
        onClick={() => onUpdate({...defaultPaymentMethods, creditCard: !defaultPaymentMethods.creditCard})}
      >
        <Space style={{fontSize: '14px'}}>
          <FontAwesomeIcon icon={faCreditCard} />
          Card
        </Space>
      </CheckboxButton>
      <CheckboxButton
        checked={defaultPaymentMethods.ach}
        onClick={() => onUpdate({...defaultPaymentMethods, ach: !defaultPaymentMethods.ach})}
      >
        <Space style={{fontSize: '16px'}}>
          <FontAwesomeIcon icon={faBank} />
          Bank Transfer
        </Space>
      </CheckboxButton>
    </VSpace>
  </SettingsTitledCard>
}

export default DefaultPaymentMethodsCard